import {Component, Input, OnInit} from '@angular/core';
import {RbdModel} from '../../../modelos/rbd.model';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
